import styled from '@emotion/styled';
import Color from 'color';

const DisplayField = styled.div(props => {
  return ({
    backgroundColor: Color(props.theme.primaryColor)
      .alpha(0.15)
      .rgb()
      .string(),
    borderLeft: `5px solid ${props.theme.primaryColor}`,
    paddingLeft: '16px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '5px',
    height: '40px',
    boxSizing: 'border-box',
    color: props.theme.primaryColor,
    fontWeight: '600',
    fontSize: '16px',
  })
});

export default DisplayField;
